export default __webpack_public_path__ + "static/media/PropertyDev_IMG-Tropicana.6cc27be5.png";